import { render } from "./bonmotComponent.vue?vue&type=template&id=1882bbcd"
import script from "./bonmotComponent.vue?vue&type=script&lang=js"
export * from "./bonmotComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__